import React, { Component } from 'react'
import Select from 'react-select'
import axios from 'axios'
import { api } from '../utils/Api'

export default class SubplantPicker extends Component {
    constructor(props) {
        super(props)

        this.state = {
            selectedOption: '',
            isSearchable: true,
            options: []
        }
    }

    getPlant = async () => {
        if(this.props.plant !== ''){
            const url = api + `/plant/${this.props.plant}`
            const token = localStorage.getItem('token')
            axios.defaults.headers.common = {'Authorization': `Bearer ${token}`}

            try {
                const { data } = await axios.get(url)
                this.setState({
                    options: data.subplants
                })
            } catch (err) {
                console.error(err.message)
                return null
            }
        }
    }

    componentDidMount() {
        this.getPlant()
    }

    render() {
        let options = this.state.options.filter(value => value.active).map((item) => {
            return {
                value: item._id,
                label: item.name
            }
        })

        if(this.props.isComplete) {
            options.push({value: 'All', label: 'All'})
        }

        return (
            <div>
                <Select
                    name="form-field-name"
                    placeholder='Subplant...'
                    // value={this.state.value}
                    value={options.filter((o) => { return o.label === this.props.value })}
                    onChange={this.props.action}
                    isSearchable={this.state.isSearchable}
                    options={options}
                />
                {
                    this.props.isRequired &&
                    <input
                        tabIndex={-1}
                        autoComplete="off"
                        style={{ opacity: 0, height: 0 }}
                        value={this.props.value}
                        required
                    />
                }
            </div>
        )
    } 
}
